<template>
  <div class="search">
    <template v-if="btnType === 'icon'">
      <div class="search-wrapper-icon" @click="onClick">
        <i class="icon material-icons">
          search
        </i>
      </div>
    </template>
    <template v-else-if="btnType === 'button'">
      <div class="search-wrapper-btn">
        <div class="btn" @click="onClick" />
      </div>
    </template>
    <template v-else>
      <div class="search-wrapper-icon mobile" @click="onClick">
        <i class="icon material-icons">
          search
        </i>
      </div>
      <div class="search-wrapper-btn mobile">
        <div class="btn" @click="onClick">
          <i class="inner-icon material-icons">
            search
          </i>
          <span class="inner-text">
            {{ $t('SEARCH.SEARCH_IN') }}{{ $t(`${this.$production.toUpperCase()}.TITLE`) }}
          </span>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'SearchButton',
  components: {},
  props: {
    btnType: {
      type: String,
      default: undefined
    }
  },
  data() {
    return {}
  },
  methods: {
    onClick() {
      this.$router.push({ name: 'search' })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.search {
  display: inline-block;
  vertical-align: middle;
  .mobile {
    display: none;
  }
  &-wrapper-icon {
    line-height:  64px;
    cursor: pointer;
    .icon {
      font-size: 24px;
      vertical-align: middle;
      color: $grey-7d;
      @include default-link-hover($grey-7d);
    }
  }
  &-wrapper-icon:hover {
    color: $link-hover;
  }
  &-wrapper-btn {
    line-height: 64px; // default
    cursor: pointer;
    .btn {
      display: inline-block;
      vertical-align: middle;
      width: 190px;
      height: 36px;
      border-radius: 18px;
      font-size: 14px;
      font-weight: 500;
      text-align: left;
      background-color: $grey-f3;
      .inner-icon {
        display: inline-block;
        vertical-align: top;
        line-height: 36px;
        margin-left: 16px;
        color: $grey-7d;
      }
      .inner-text {
        display: inline-block;
        vertical-align: top;
        line-height: 36px;
        color: $grey-9b;
      }
    }
  }
}
@media only screen and (min-width: 1440px) {
  .search {
    &-wrapper-icon.mobile {
      display: none;
    }
    &-wrapper-btn.mobile {
      display: inline-block;
    }
  }
}

@media only screen and (min-width: 1024px) and (max-width: 1439.98px) {
  .search {
    &-wrapper-icon.mobile {
      display: none;
    }
    &-wrapper-btn.mobile {
      display: inline-block;
    }
  }
}

@media only screen and (min-width: 768px) and (max-width: 1023.98px) {
  .search {
    &-wrapper-icon.mobile {
      display: inline-block;
    }
    &-wrapper-btn.mobile {
      display: none;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .search {
    &-wrapper-icon.mobile {
      display: inline-block;
    }
    &-wrapper-btn.mobile {
      display: none;
    }
  }
}
</style>
